<template>
  <u-animate-container id="index_quality">
    <div class="container">
      <u-animate class="item" name="bounceInLeft" delay="0s" duration="1s" :iteration="1" :offset="0" animateClass="animated" :begin="false" >
        <div class="item_img">
          <img src="@/assets/images/icon_ymjc_1.png">
        </div>
        <p>{{$t('index.quality.a')}}</p>
      </u-animate>
      <u-animate class="item" name="bounceInLeft" delay="0s" duration="1s" :iteration="1" :offset="0" animateClass="animated" :begin="false" >
        <div class="item_img">
          <img src="@/assets/images/icon_zysb_1.png">
        </div>
        <p>{{$t('index.quality.b')}}</p>
      </u-animate>
      <u-animate class="item" name="bounceInLeft" delay="0s" duration="1s" :iteration="1" :offset="0" animateClass="animated" :begin="false" >
        <div class="item_img">
          <img src="@/assets/images/icon_jdjs_1.png">
        </div>
        <p>{{$t('index.quality.c')}}</p>
      </u-animate>
      <u-animate class="item" name="bounceInLeft" delay="0s" duration="1s" :iteration="1" :offset="0" animateClass="animated" :begin="false" >
        <div class="item_img">
          <img src="@/assets/images/icon_zdnxl_2.png">
        </div>
        <p>{{$t('index.quality.d')}}</p>
      </u-animate>
    </div>
    <u-animate class="btn_quality" name="zoomIn" delay="1s" duration="1s" :iteration="1" :offset="0" animateClass="animated" :begin="false" >
      {{$t('index.quality.btn')}}
    </u-animate>
  </u-animate-container>
</template>

<script>
import {UAnimateContainer, UAnimate} from 'vue-wow'
export default {
  components: {
    UAnimateContainer,
    UAnimate
  },
  props: {
    locale: {
      type: String,
      default: 'cn'
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
  #index_quality{
    width:100%;
    box-sizing: border-box;
    padding:60px 0;
    height:auto;
    overflow: hidden;
    background:#fff;
    position:relative;
    text-align:center;
    .container{
      width:1140px;
      height:auto;
      overflow:hidden;
      margin:0 auto;
      .item{
        width:255px;
        height:auto;
        overflow:hidden;
        box-sizing: border-box;
        float:left;
        margin-right:40px;
        .item_img{
          border:2px solid #FD8204;
          border-radius: 50%;
          width:150px;
          height:150px;
          position:relative;
          margin:0 auto;
          img{
            position:absolute;
            top:0;
            left:0;
            right:0;
            bottom:0;
            margin:auto;
            width:80px;
            height:auto;
          }
        }
        p{
          font-size: 0.25rem;
          text-align: center;
          margin-top: 20px;
          line-height: 1.2;
        }
        &:last-of-type{
          margin-right: 0;
          .item_img{
            border-color:#e04403;
            background:#e04403;
          }
        }
      }
    }
    .btn_quality{
      color:#fd8204;
      font-size:16px;
      border:2px solid #FD8204;
      border-radius: 25px;
      height:45px;
      line-height: 45px;
      text-align: center;
      font-weight: bold;
      transition: all .35s;
      margin:45px auto 0;
      cursor: pointer;
      display: inline-block;
      position: relative;
      padding:0 25px;
      &:hover{
        background:#FD8204;
        color:#fff;
      }
    }
  }
  @media screen and (max-width: 750px) {
     #index_quality{
       width:100%;
       padding:30px 0 15px 0;
       .container{
         width:100%;
         .item{
           width:50%;
           margin-right:0;
           margin-bottom:1.5rem;
           .item_img{
             width:100px;
             height:100px;
             img{
               width:50px;
               height:auto;
             }
           }
           p{
             font-size:1rem;
           }
         }
       }
       .btn_quality{
         margin-top:0.4rem;
         display: none;
       }
     }
  }
</style>



// WEBPACK FOOTER //
// src/pages/components/Index/IndexQuality.vue